<div
  class="header-container"
  [ngClass]="{
    'header-container--tablet': screenLayoutService.tablet$ | async,
    'header-container--phone': screenLayoutService.phone$ | async,
  }"
>
  <div
    class="header-item server-cards-container"
    [ngClass]="{
      'header-item--desktop-large': screenLayoutService.desktopLarge$ | async,
      'header-item--desktop': screenLayoutService.desktop$ | async,
      'header-item--tablet': screenLayoutService.tablet$ | async,
      'header-item--phone': screenLayoutService.phone$ | async,
    }"
  >
    <app-dna-syngovia-carousel
      [carouselData]="healthcheckData.serversHealthcheck"
    >
      <ng-template #carouselItem let-server>
        <button
          class="server-card"
          [class.server-card--selected]="server === selectedServerHealthcheck"
          (click)="onSelectServerHealthcheck(server)"
          tabindex="0"
        >
          <sh-icon icon="pacs" size="m"></sh-icon>
          <div class="server-card-description">
            <sh-text size="body-1" color="secondary">
              {{ server.msl }}
            </sh-text>
            <sh-text size="body-2" color="secondary">
              SN {{ server.serialNumber }}
            </sh-text>
          </div>
          <sh-icon
            icon="warning"
            size="s"
            *ngIf="server.serverHealthcheckData.summary.totalScore >= 100"
          ></sh-icon>
        </button>
      </ng-template>
    </app-dna-syngovia-carousel>
  </div>
  <div
    class="header-item summary-container"
    [ngClass]="{
      'header-item--desktop-large': screenLayoutService.desktopLarge$ | async,
      'header-item--desktop': screenLayoutService.desktop$ | async,
      'header-item--tablet': screenLayoutService.tablet$ | async,
      'header-item--phone': screenLayoutService.phone$ | async,
    }"
  >
    <app-dna-syngovia-healthcheck-summary
      [healthcheckSummary]="
        selectedServerHealthcheck?.serverHealthcheckData.summary
      "
    ></app-dna-syngovia-healthcheck-summary>
  </div>
</div>

<ng-container
  *ngIf="
    selectedServerHealthcheck?.serverHealthcheckData.issues.length > 0;
    else noIssuesFound
  "
>
  <div class="table-container">
    <app-dna-syngovia-healthcheck-issues-table
      [issuesIdentifiedAt]="
        selectedServerHealthcheck?.serverHealthcheckData.issuesIdentifiedAt
      "
      [issues]="selectedServerHealthcheck?.serverHealthcheckData.issues"
      [serialNumber]="selectedServerHealthcheck?.serialNumber"
      [materialNumber]="selectedServerHealthcheck?.materialNumber"
    ></app-dna-syngovia-healthcheck-issues-table>
  </div>
</ng-container>

<ng-template #noIssuesFound>
  <div class="empty-state-container">
    <sh-empty-state
      icon="success"
      icon-color="secondary"
      label="{{ 'syngovia.label.noIssuesFoundForThisServer' | translate }}"
    ></sh-empty-state>
  </div>
</ng-template>
